import { render } from "./App.vue?vue&type=template&id=3b4a65ee"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/denis/Coding/projects/kraiburg-website-typo3-13lts/extensions/blog/Resources/Private/Vue/blog-entry-list/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__